import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl } from 'react-intl'

import Label from '../label'

class InputPassword extends React.Component {

    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        waitInMs: PropTypes.number
    }

    constructor(props){
        super(props);
        this.state = {
            value: props.value,
            error: false
        };
    }

    onChange(event) {
        let { value } = event.target
        this.props.onChange && this.props.onChange(value);
        this.setState({value})
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({value: nextProps.value})
    }

    render() {
        let { intl, label=false, placeholder=false, className=false } = this.props;
        let { value } = this.state;

        return <div className={"form form-text" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>
            <div className='form-data'>
                <input type="password"
                    placeholder={placeholder ? intl.formatMessage({id:placeholder}) : ''}
                    onChange={this.onChange.bind(this)}
                    value={value} />
            </div>
        </div>
    }
}

InputPassword.defaultProps = {
    errorStr: 'app.error',
    value: ''
}

export default injectIntl(InputPassword)

